<template>
    <div>
        <!--頁首-->
        <Header :header="header" ></Header>
        <!--功能列表-->
        <Menulist :menulist="menulist"></Menulist>
        <!--功能列表_RWD-->
        <Menulist_RWD :menulist="menulist"></Menulist_RWD>
        <!--網站導覽頁面-->
        <main class="main">
            <!--網站路徑(麵包屑)-->
            <Sitebar :sider="sider" ></Sitebar>
            <!--網站導覽-->
            <div class="inconbox">
                <!--標題-手機板-->
                <div class="Rwd_subtitle">sitemap</div>
                <!--各項主類別及次分類-->
                <div class="sitmapall">
                    <!--最新消息-->
                    <div class="sitpbox">
                        <!--主類別名稱-->
                        <div class="sitpbox_title">
                            1. News
                        </div>
                        <!--次類別名稱-->
                        <div class="sitbawal">
                            <div class="sitpbox_stbar" v-for="(item , index) in GetSublist('PJ202503')">
                                <a :href="'/EN/News?PJ_ID='+item.PJ_ID+ '&modal='+item.modal">
                                    <!--次分類標號-->
                                    <span class="sitpbox_stal_num">{{ "1-"+ (index+1) }}</span>
                                    <!--次分類標題-->
                                    <span class="sitpbox_stal_wd">{{ item.PJ_ENAME }}</span>
                                </a>
                            </div>
                        </div>
                    </div>
                    <!--關於生傳-->
                    <div class="sitpbox">
                        <!-- TODO 動態取得次分類-->
                        <!--主類別名稱-->
                        <div class="sitpbox_title">
                            2. About us
                        </div>
                        <!--次類別名稱-->
                        <div class="sitbawal">
                            <div class="sitpbox_stbar" v-for="(item , index) in GetSublist('PJ202504')">
                                <a :href="'/EN/About?PJ_ID='+item.PJ_ID+ '&modal='+item.modal">
                                    <!--次分類標號-->
                                    <span class="sitpbox_stal_num">{{ "2-"+(index+1) }}</span>
                                    <!--次分類標題-->
                                    <span class="sitpbox_stal_wd">{{ item.PJ_ENAME }}</span>
                                </a>
                            </div>
                        </div>
                    </div>
                    <!--系所成員-->
                    <div class="sitpbox">
                        <!-- TODO 動態取得次分類-->
                        <!--主類別名稱-->
                        <div class="sitpbox_title">
                            3. Member
                        </div>
                        <!--次類別名稱-->
                        <div class="sitbawal">
                            <div class="sitpbox_stbar" v-for="(item , index) in GetSublist('PJ202505')">
                                <a :href="'/EN/Member?PJ_ID='+item.PJ_ID+ '&modal='+item.modal">
                                    <!--次分類標號-->
                                    <span class="sitpbox_stal_num">{{ "3-"+(index+1) }}</span>
                                    <!--次分類標題-->
                                    <span class="sitpbox_stal_wd">{{ item.PJ_ENAME }}</span>
                                </a>
                            </div>
                        </div>
                    </div>
                    <!--招生訊息-->
                    <div class="sitpbox">
                        <!-- TODO 動態取得次分類-->
                        <!--主類別名稱-->
                        <div class="sitpbox_title">
                            4. Admissions
                        </div>
                        <!--次類別名稱-->
                        <div class="sitbawal">
                            <div class="sitpbox_stbar" v-for="(item , index) in GetSublist('PJ202506')">
                                <a :href="'/EN/Admissions?PJ_ID='+item.PJ_ID+ '&modal='+item.modal">
                                    <!--次分類標號-->
                                    <span class="sitpbox_stal_num">{{ "4-"+(index+1) }}</span>
                                    <!--次分類標題-->
                                    <span class="sitpbox_stal_wd">{{ item.PJ_ENAME }}</span>
                                </a>
                            </div>
                        </div>
                    </div>
                    <!--課程資訊-->
                    <div class="sitpbox">
                        <!-- TODO 動態取得次分類-->
                        <!--主類別名稱-->
                        <div class="sitpbox_title">
                            5. Curriculum
                        </div>
                        <!--次類別名稱-->
                        <div class="sitbawal">
                            <div class="sitpbox_stbar" v-for="(item , index) in GetSublist('PJ202507')">
                                <a :href="'/EN/Curriculum?PJ_ID='+item.PJ_ID+ '&modal='+item.modal">
                                    <!--次分類標號-->
                                    <span class="sitpbox_stal_num">{{ "5-"+(index+1) }}</span>
                                    <!--次分類標題-->
                                    <span class="sitpbox_stal_wd">{{ item.PJ_ENAME }}</span>
                                </a>
                            </div>
                        </div>
                    </div>
                    <!--學術研究-->
                    <div class="sitpbox">
                        <!-- TODO 動態取得次分類-->
                        <!--主類別名稱-->
                        <div class="sitpbox_title">
                            6. Research
                        </div>
                        <!--次類別名稱-->
                        <div class="sitbawal">
                            <div class="sitpbox_stbar" v-for="(item , index) in GetSublist('PJ202508')">
                                <a :href="'/EN/Research?PJ_ID='+item.PJ_ID+ '&modal='+item.modal">
                                    <!--次分類標號-->
                                    <span class="sitpbox_stal_num">{{ "6-"+(index+1) }}</span>
                                    <!--次分類標題-->
                                    <span class="sitpbox_stal_wd">{{ item.PJ_ENAME }}</span>
                                </a>
                            </div>
                        </div>
                    </div>
                    <!--常用表單-->
                    <div class="sitpbox">
                        <!-- TODO 動態取得次分類-->
                        <!--主類別名稱-->
                        <div class="sitpbox_title">
                            <a href="/EN/Forms">
                                7. Forms
                            </a>
                        </div>
                    </div>
                    <!--友站連結-->
                    <div class="sitpbox">
                        <!-- TODO 動態取得次分類-->
                        <!--主類別名稱-->
                        <div class="sitpbox_title">
                            8. Links
                        </div>
                        <!--次類別名稱-->
                        <div class="sitbawal">
                            <div class="sitpbox_stbar" v-for="(item , index) in GetSublist('PJ202510').filter(x => { return x.modal==langurage })">
                                <a :href="item.PJ_ENAME" target="_blank">
                                    <!--次分類標號-->
                                    <span class="sitpbox_stal_num">{{ "8-"+(index+1) }}</span>
                                    <!--次分類標題-->
                                    <span class="sitpbox_stal_wd">{{ item.PJ_NAME }}</span>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
        <!--頁尾-->
        <Footer :footer="footer"></Footer>
        <!--goto按鈕-->
        <GoTop></GoTop>
    </div>
</template>
<script>
import Header from '../../components/default_en/NavBar/Header.vue';
import Menulist from '../../components/default_en/NavBar/Menulist.vue';
import Menulist_RWD from '../../components/default_en/NavBar/Menulist_RWD.vue';
import Sitebar from '../../components/default_en/NavBar/Sitebar.vue';
import Footer from '../../components/default_en/NavBar/Footer.vue';
import GoTop from '../../components/default_en/Tool/GoTop.vue';

export default{
    components:{
        Header,
        Menulist,
        Menulist_RWD,
        Sitebar,
        Footer,
        GoTop,
    },
    data(){
        return {
            //頁首
            header:{
                text1:"sitemap",
                text2: null,
            },
            //功能列表 &功能列表_RWD
            menulist:{
                place:""
            },
            //網站路徑(麵包屑)
            sider:{
                index:2,
                type: 0,
                list:[{text:"sitemap",url:null}],
            },
            //頁尾            
            footer:{
                
            },
            //語言
            langurage: "2",
            //內容資料
            headerData:{},
        }
    },
    computed:{},
    mounted(){
        //初始化
        this.init();
    },
    watch:{
        "$route.query"(){
            //初始化
            this.init();
        },
    },
    methods:{
        init(){
            if(this.$route.query){
                this.langurage = this.$route.query.lang? this.$route.query.lang: "2";
            }

            //取得類別子物件
            this.getHeader();

        },
        async getHeader(){
            try {
                //POST 參數
                let jsonReq = {
                    TYPE:"GET_MENU_OPTION",
                };
                //Token
                let resToken = await this.userRequest.post("bicd/Token");
                jsonReq.Token = resToken.data;
                //執行API功能
                let res = await this.userRequest.post("bicd/Project",jsonReq);
                //讀取資料
                let json = JSON.parse(res.data);
                if(json.Status){
                    let jsonData = JSON.parse(json.Data);
                    //設定類別
                    this.headerData = jsonData;
                }
            }catch(err){
                console.log("ErrFunction: getHeader/n "+err);
            }
        },
        //取得切割類別
        GetSublist(PJ_ID){
            //判斷資料列表是否存在，無則回傳空值
            if (!Array.isArray(this.headerData)) return [];
            //TODO 僅取得指定類別的所有次類別資料
            var headerDatas = (this.headerData.filter(item => item.PJ_ID == PJ_ID))[0].SubList;
            return headerDatas;
        }

    }
    
}
</script>